import React, { useState } from "react";
import {
  Badge,
  Button,
  Container,
  Form,
  Tab,
  Table,
  Tabs,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import { FaRegDotCircle, FaFacebookF } from "react-icons/fa";
import {
  AiFillStar,
  AiOutlineStar,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import "./ProductDetailsBanner.css";
import cat1 from "../../../images/categories/cat1.png";
import cat2 from "../../../images/categories/cat2.png";
import cat3 from "../../../images/categories/cat3.png";
import preview from "../../../images/product-details/product-details.jpg";
import Magnifier from "react-magnifier";
import useAuth from "../../../Hooks/useAuth";
const ProductDetailsBanner = () => {
  const [previewImg, setPreviewImg] = useState(preview);
  const { handleShow, showToast, closeToast, addToCart } = useAuth();
  const categories = [
    {
      productId: 1,
      productImg: cat1,
      catName: "Pants",
    },
    {
      productId: 2,
      productImg: cat2,
      catName: "T-shirt",
    },
    {
      productId: 3,
      productImg: cat3,
      catName: "Shoe",
    },
    {
      productId: 4,
      productImg: cat1,
      catName: "Pants",
    }
  ];

  const testform = (e) => {
    e.preventDefault();
    alert(1);
  };

  return (
    <div className="product-details-banner">
      <Container>
        {showToast && (
          <ToastContainer
            className="p-3 position-fixed"
            position="middle-center"
          >
            <Toast
              className="bg-info border-0 text-light"
              show={showToast}
              onClose={closeToast}
            >
              <Toast.Header>
                <img
                  src="holder.js/20x20?text=%20"
                  className="rounded me-2"
                  alt=""
                />
                <strong className="me-auto">Notification</strong>
                <small>Just Now</small>
              </Toast.Header>
              <Toast.Body>
                <p>Successfully product added to the cart</p>
                <Button
                  onClick={handleShow}
                  variant="info"
                  className="border text-light border-1 border-light rounded-0"
                >
                  View Cart
                </Button>
              </Toast.Body>
            </Toast>
          </ToastContainer>
        )}

        <div className="row">
          <div className="col-12 col-md-12 col-lg-6 col-xl-6 p-2">
            <div className="details-image-preview">
              <div className="preview-img">
                <Magnifier
                  mgShape="square"
                  mgHeight={478}
                  mgWidth={478}
                  src={previewImg}
                  className="w-100 h-100"
                ></Magnifier>
              </div>
              <div className="preview-slider">
                {categories.map((cat, y) => (
                  <div
                    key={y}
                    onClick={() => setPreviewImg(cat.productImg)}
                    className="slider-image pointer"
                  >
                    <img src={cat.productImg} alt="" className="h-100 w-100" />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-12 col-md-12 col-lg-6 col-xl-6 p-2">
            <div className="product-details-info">
              <h2 className="fw-normal">Women Stylish Skirt</h2>
              <div className="d-flex align-items-center">
                <div className="d-flex align-items-center">
                  <AiFillStar className="me-1 text-warning" />
                  <AiFillStar className="me-1 text-warning" />
                  <AiFillStar className="me-1 text-warning" />
                  <AiFillStar className="me-1 text-warning" />
                  <AiFillStar className="me-1 text-warning" />
                </div>
                <h5 className="m-0 fw-light">2 review</h5>
              </div>
              <div className="d-flex align-items-center">
                <del>
                  <h5 className="m-0 fw-normal text-secondary">$18.33</h5>
                </del>
                <h3 className="m-0 ms-2 fw-normal">$15.33</h3>
              </div>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quas
                omnis debitis voluptates non illum. Placeat, dignissimos ex
                similique labore autem perferendis facilis voluptatibus nam
                tempora corrupti, earum qui laudantium distinctio architecto.
                Nam adipisci culpa deleniti quasi officiis tempore? Ratione
              </p>
              <div>
                <div className="color-option-container py-3 border-top">
                  <div className="row align-items-center">
                    <div className="col-3 col-md-2">
                      <h5 className="fw-light">Color :</h5>
                    </div>
                    <div className="col-9 col-md-5">
                        <ul className="d-flex align-items-center justify-content-between pt-3">
                          <li>
                            <div className="color-box bg-success"></div>
                          </li>
                          <li>
                            <div className="color-box bg-danger"></div>
                          </li>
                          <li>
                            <div className="color-box bg-warning"></div>
                          </li>
                          <li>
                            <div className="color-box bg-primary"></div>
                          </li>
                          <li>
                            <div className="color-box bg-info"></div>
                          </li>
                          <li>
                            <div className="color-box bg-dark"></div>
                          </li>
                          <li>
                            <div className="color-box bg-light border"></div>
                          </li>
                        </ul>
                    </div>
                  </div>
                </div>
                <div className="color-option-container py-3 border-top">
                  <div className="row align-items-center">
                    <div className="col-3 col-md-2">
                      <h5 className="fw-light">Size :</h5>
                    </div>
                    <div className="col-9 col-md-10">
                      <div className="d-flex align-items-center">
                        <Badge bg="dark" text="light" className="mx-1">
                          Medium
                        </Badge>
                        <Badge bg="dark" text="light" className="mx-1">
                          Large
                        </Badge>
                        <Badge bg="dark" text="light" className="mx-1">
                          Extra large
                        </Badge>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="py-3 border-top border-bottom">
                <div className="action-button d-flex align-items-center">
                  <div className="quantity-container d-flex align-items-center justify-content-between border">
                    <div className="quantity-button">
                      <Button className="rounded-0 text-dark border-0 border-end bg-transparent p-2">
                        -
                      </Button>
                    </div>
                    <div className="quantity">
                      <Button className="rounded-0 text-dark border-0  bg-transparent p-2">
                        0
                      </Button>
                    </div>
                    <div className="quantity-button">
                      <Button className="rounded-0 text-dark border-0 border-start bg-transparent p-2">
                        +
                      </Button>
                    </div>
                  </div>
                  <Button
                    onClick={addToCart}
                    variant="dark"
                    className="rounded-0 p-2 border ms-2"
                  >
                    Add to Cart
                  </Button>
                </div>
              </div>
              <div className="py-3">
                <div className="d-flex align-items-center">
                  <div className="icon-box">
                    <FaFacebookF />
                  </div>
                  <div className="icon-box ms-2">
                    <AiFillInstagram />
                  </div>
                  <div className="icon-box ms-2">
                    <AiOutlineTwitter />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="product-information mt-3">
          <Tabs
            defaultActiveKey="home"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="home" title="Description">
              <div>
                <div className="product-details">
                  <p>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Amet perspiciatis saepe nam eos ut. Quae fuga odit error
                    tempore vero neque voluptas assumenda voluptatum sequi saepe
                    ratione perspiciatis sint eos excepturi, dolor, adipisci
                    deserunt. Eos, doloremque id officia minus impedit delectus
                    illum quibusdam officiis iste nostrum blanditiis, vitae
                    numquam eligendi corrupti cumque consequuntur quam at nisi.
                    Accusamus harum sit iste.
                  </p>
                  <div>
                    <ul>
                      <li>
                        <span>
                          <FaRegDotCircle className="me-2" />
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit.
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaRegDotCircle className="me-2" />
                          Lorem ipsum dolor sit ur adipisicing elit.
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaRegDotCircle className="me-2" />
                          Lorem ipsum doltetur adipisicing elit.
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaRegDotCircle className="me-2" />
                          Lorem ipsum dolor sit amet consectpisicing elit.
                        </span>
                      </li>
                      <li>
                        <span>
                          <FaRegDotCircle className="me-2" />
                          Lorem ipsum dolortur adipisicing elit.
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="profile" title="Additional Information">
              <div className="table-container">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Serial No</th>
                      <th>Product Name</th>
                      <th>Price</th>
                      <th>Color</th>
                      <th>Size</th>
                      <th>Stock</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>Women Stylish Skirt</td>
                      <td>15.33</td>
                      <td>red,merun,green</td>
                      <td>M,L,XL,XXL</td>
                      <td>Yes</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Tab>
            <Tab eventKey="contact" title="Reviews">
              <div>
                <div className="row">
                  <div className="col-12 col-md-12 col-lg-8 col-xl-8">
                    <div>
                      <h4 className="fw-normal">3 Revirew</h4>
                      <div className="d-flex my-3">
                        <div className="review-user-img">
                          <img
                            src={require("../../../images/users/user1.png")}
                            alt=""
                            className="h-100 w-100"
                          />
                        </div>
                        <div className="review-user-info ms-2">
                          <div className="d-flex">
                            <AiFillStar />
                            <AiFillStar />
                            <AiFillStar />
                            <AiOutlineStar />
                            <AiOutlineStar />
                          </div>
                          <div className="d-flex align-items-center">
                            <h5 className="m-0 fw-light">Marry Ann</h5>
                            <span className="ms-3 text-secondary">
                              22-July-2022
                            </span>
                          </div>
                          <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Voluptatum, nam doloribus! Error ab voluptatem
                            tempora, dicta velit nemo expedita iste amet enim
                            dolorem sint eum sed, repellendus, dignissimos fuga
                            reiciendis illo sapiente ipsum dolore reprehenderit
                            itaque iure
                          </p>
                        </div>
                      </div>
                      <div className="d-flex my-3">
                        <div className="review-user-img">
                          <img
                            src={require("../../../images/users/user2.png")}
                            alt=""
                            className="h-100 w-100"
                          />
                        </div>
                        <div className="review-user-info ms-2">
                          <div className="d-flex">
                            <AiFillStar />
                            <AiFillStar />
                            <AiFillStar />
                            <AiOutlineStar />
                            <AiOutlineStar />
                          </div>
                          <div className="d-flex align-items-center">
                            <h5 className="m-0 fw-light">Jared Dinn</h5>
                            <span className="ms-3 text-secondary">
                              22-July-2022
                            </span>
                          </div>
                          <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Voluptatum, nam doloribus! Error ab voluptatem
                            tempora, dicta velit nemo expedita iste amet enim
                            dolorem sint eum sed, repellendus, dignissimos fuga
                            reiciendis illo sapiente ipsum dolore reprehenderit
                            itaque iure
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-4 col-xl-4">
                    <div className="comment-container">
                      <h4 className="fw-normal">Add a comment here</h4>
                      <Form onSubmit={testform}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>Personal Rating</Form.Label>
                          <Form.Control
                            defaultValue={0}
                            type="number"
                            placeholder="Your Rating"
                            className="rounded-0"
                          />
                        </Form.Group>

                        <Form.Group
                          className="mb-3"
                          controlId="formBasicPassword"
                        >
                          <Form.Control
                            rows="4"
                            className="rounded-0"
                            as="textarea"
                            placeholder="Leave a comment here"
                          />
                        </Form.Group>

                        <Button
                          variant="light"
                          className="border rounded-0"
                          type="submit"
                        >
                          Add a review
                        </Button>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
      </Container>
    </div>
  );
};

export default ProductDetailsBanner;
